<template>
  <div>
    <a-table
      :columns="columns"
      :dataSource="document.HISTORY"
      :pagination="{ 'show-size-changer':true }"
      size="middle"
      bordered
    ></a-table>
    <div style="margin-bottom: 15px;text-align:center">
      <a-button type="danger" @click="handlerBack">{{$t('Close')}}</a-button>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "document",
    "fieldColumns",
    "prew_history",
    "USER_LIST",
    "MY_COMPANY_LIST",
    "COMPANY_LIST"
  ],
  data() {
    const columns = [
      {
        title: this.$t("Date of change"),
        dataIndex: "date_change",
        width: 200
      },
      {
        title: this.$t("User"),
        dataIndex: "creator",
        width: 300,
        customRender: text =>
          this.getUser(text)
      },
      {
        title: this.$t("Change type"),
        dataIndex: "type_change",
        width: 150,
        customRender: text => {
          let kk = this.fieldColumns.find(x => x.dataIndex == text);
          if (kk) {
            return kk.title;
          }
          return "";
        }
      },
      {
        title: this.$t("Old value"),
        dataIndex: "old",
        ellipsis: true,
        width: "30%",
        customRender: (text, record) => {
          let kk = this.fieldColumns.find(
            x => x.dataIndex == record.type_change
          );
          if (kk?.customRender) {
            let param = {};
            param[kk.dataIndex] = text;
            return kk.customRender(text, param);
          }
          //   if (record.type_change in this.info) {
          //     let comp = this.info[record.type_change].find(x => x.ID == text);
          //     return comp != undefined ? comp.TITLE : "";
          //   } else if (record.type_change == "kontragent") {
          //     let comp = this.info.company.find(x => x.ID == text);
          //     return comp != undefined ? comp.TITLE : "";
          //   } else if (record.type_change == "key_words" && text != "null") {
          //     return JSON.parse(text).reduce(
          //       (accumulator, currentValue) => accumulator + ", " + currentValue
          //     );
          //   } else {
          //     return text == "null" ? "" : text;
          //   }
          return text;
        }
      },
      {
        title: this.$t("New value"),
        dataIndex: "new",
        ellipsis: true,
        width: "30%",
        customRender: (text, record) => {
          let kk = this.fieldColumns.find(
            x => x.dataIndex == record.type_change
          );
          if (kk?.customRender) {
            let param = {};
            param[kk.dataIndex] = text;
            return kk.customRender(text, param);
          }
          // if (record.type_change in this.info) {
          //   let comp = this.info[record.type_change].find(x => x.ID == text);
          //   return comp.TITLE;
          // } else if (record.type_change == "kontragent") {
          //   let comp = this.info.company.find(x => x.ID == text);
          //   return comp != undefined ? comp.TITLE : "";
          // } else if (record.type_change == "key_words" && text != "null") {
          //   return JSON.parse(text).reduce(
          //     (accumulator, currentValue) => accumulator + ", " + currentValue
          //   );
          // } else {
          return text;
          // }
        }
      }
    ];
    return {
      count: 10,
      document_record: 0,
      columns
    };
  },
  methods: {
    handlerBack() {
      this.$emit("onBack");
    },
    getUser(id) {
      let user = this.document.userInfo.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : '';
    },
  }
};
</script>
<style scoped>
</style>
